<template>
  <v-list class="transparent">
    <v-row>
      <template v-if="listStillLoading">
        <v-col v-for="sket in 9" :key="sket" cols="12" md="4">
          <v-skeleton-loader
            boilerplate
            type="list-item-three-line"
            loading
          ></v-skeleton-loader>
        </v-col>
      </template>
      <template v-else>
        <v-col
          cols="12"
          md="4"
          xl="3"
          v-for="item in items"
          :key="item._id"
          transition="fade-transition"
        >
          <v-card shaped :to="`dikr/${item.slug}`" router class="elevation-4">
            <v-list-item>
              <v-list-item-icon class="ml-4">
                <v-icon color="secondary">fa-mosque</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.TITLE }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="secondary">fa-chevron-left</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-list>
</template>

<script>
export default {
  name: "DikrList",
  props: {
    items: {
      type: Array,
      require: true,
    },
  },
  data: () => ({
    listStillLoading: true,
  }),
  mounted() {
    this.listStillLoading = false;
  },
};
</script>
